import axios from 'axios';
import { config } from '../config';
import { store } from '../index';

const DEFAULT_TIMEOUT = 60 * 1000;

const client = axios.create({
  baseURL: config.apiUrl,
  timeout: DEFAULT_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  withCredentials: true,
});

const getUserType = () => {
  return store.getState().user.user.type;
}

client.interceptors.request.use((clientConfig) => {
  if (config.tokensEnabled) {
    clientConfig.params = clientConfig.params || {};
    clientConfig.params['token'] = config.tokens.get(getUserType());
  }

  return clientConfig;
}, (error: Error) => {
  return Promise.reject(error);
})

export default client;
